function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 13,
  width: 4,
  height: 5,
  fill: "currentColor"
}, React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 13,
  width: 4,
  height: 5,
  fill: "currentColor"
}, React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20,
  y: 13,
  width: 4,
  height: 5,
  fill: "currentColor"
}, React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

const SvgLoading = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 30",
  style: {
    enableBackground: "new 0 0 50 50"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), _ref, _ref2, _ref3);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading.b67f8858.svg";
export { ForwardRef as ReactComponent };